<template>
    <div>
        <div class="row" v-show="isLoading">
            <div class="text-center col-12 py-3">
                <span class="spinner-border" role="status"></span>
            </div>
        </div>
        <div class="card mb-3" v-for="category in documentCategories" :key="category.id">
            <div class="card-body">
                <h2 class="text-2xl" v-html="category.title"></h2>
                <p class="help-block">{{ category.description }}</p>

                <table class="table table-responsive d-md-table" v-if="category.documents.length">
                    <thead class="bg-primary-lighter text-white">
                        <tr>
                            <th class="border-0">{{ $t('Filnavn') }}</th>
                            <th class="border-0" v-if="category.display_upload_date">{{ $t('Delt') }}</th>
                            <th class="border-0 d-none d-md-table-cell">{{ $t('Valg') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(file, i) in category.documents" :key="file.id">
                            <td :class="{'border-top-0': i === 0}"><a :href="fileUrl(file)">{{ file.filename }}</a></td>
                            <td v-if="category.display_upload_date" :class="{'border-top-0': i === 0}">{{ file.uploadedAt }}
                                <div v-if="file.uploaded_by == userId">{{ $t('Delt av deg') }}</div>
                            </td>
                            <td class="d-none d-md-table-cell" :class="{'border-top-0': i === 0}">
                                <a :href="'/document/' + file.id + '?download=1'" target="_blank" class="btn btn-success btn-sm" data-bs-toggle="tooltip" :title="$t('Last ned')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon-xs" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clip-rule="evenodd" />
                                    </svg>
                                </a>
    <!--                            <a v-if="file.uploaded_by == user.studentId" href="/document/{{ file.id }}/delete" target="_blank" class="btn btn-danger btn-sm" data-toggle="tooltip" title="Slett">-->
    <!--                                <svg xmlns="http://www.w3.org/2000/svg" class="icon-xs" viewBox="0 0 20 20" fill="currentColor">-->
    <!--                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />-->
    <!--                                </svg>-->
    <!--                            </a>-->
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p v-if="!category.documents.length"><i>{{ $t('Skolen har ikke delt noen dokumenter av denne typen enda.') }} </i></p>

                <div v-if="category.show_upload_field && isStudent">
                    <hr>
                    <p><strong>{{ $t('Last opp filer til skolen din') }}:</strong></p>
                    <div class="mb-1">
                        <FileUploader :action="'/document/upload'" @uploaded="refresh" :onsuccess="refresh"></FileUploader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Store from '../../state/documentStore'
import FileUploader from '../fileuploader/FileUploader.vue'

const props = defineProps(['isstudent', 'isapp', 'hashedkey', 'userid'])
const isStudent = ref(props.isstudent)
const isApp = ref(props.isapp)
const hashedKey = ref(props.hashedkey)
const userId = ref(props.userid)

const documentCategories = computed(() => Store.getCategories())
const isLoading = computed(() => Store.isLoading())

const refresh = () => {
    Store.refresh()
}

const fileUrl = (file) => {
    return '/document/' + file.id + (isApp.value ? '?auth=' + hashedKey.value : '')
}

Store.init()
</script>